/**
 * Stage / TrialStatus — see GLOSSARY.md → Trial Authoring → Stage.
 */
export const TRIAL_STATUSES = [
  'setting_up',
  'generating',
  'in_review',
  'finalised',
  'failed',
] as const;

export type TrialStatus = (typeof TRIAL_STATUSES)[number];

const TRIAL_STATUS_SET: ReadonlySet<string> = new Set(TRIAL_STATUSES);

export const isTrialStatus = (raw: unknown): raw is TrialStatus =>
  typeof raw === 'string' && TRIAL_STATUS_SET.has(raw);

export const parseTrialStatus = (raw: unknown): TrialStatus => {
  if (isTrialStatus(raw)) return raw;
  throw new Error(`Invalid TrialStatus: ${JSON.stringify(raw)}`);
};
